import { format } from "date-fns";

import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { LanguageType } from "@/translations";

export function formatCaseNoteDateTime(
  language: LanguageType,
  date?: Date | null,
  time?: Date | null,
  timeSufix?: string
): string {
  if (!date && !time) {
    return "";
  }

  const locale = locales[language];

  const datePart = date ? format(date, "P", { locale: locale }) : "";
  const timePart = time ? format(time, "pp", { locale: locale }) : "";
  const suffix = time && timeSufix ? ` ${timeSufix}` : "";

  return `${datePart} ${timePart}${suffix}`.trim();
}
